import React from 'react'
import { addCard } from '../../service/payment/payment'
import { getProfile } from '../../service/user'
import ENV from '../../utils/env'
import { urlToObject } from '../../utils/url'
import AddCardForm from '../addCardForm'
import { isUSPhoneNumber, passInfoToOpenerOrRedirect, prepareErrorMessage } from './utils'

import Spinner from '../spinner'
import './addCardInvoice.sass'

const schema = {
  UK: 'card.flyxo.co.uk',
  AE: 'card.flyxo.ae',
  US: 'card.flyxo.com',
}

const getLoginHostUrl = () => {
  if (ENV.env === 'dev' || typeof window === 'undefined') {
    return undefined
  }

  const url = document.location.href

  if (url.includes(schema.US)) {
    return undefined
  }

  if (url.includes(schema.UK)) {
    return ENV.serverHostUK
  }

  if (url.includes(schema.AE)) {
    return ENV.serverHostAE
  }

  return undefined
}

export default class AddCardInvoice extends React.Component {
  state = {
    isInit: false,
    isLoading: false,
    submitError: null,
    profile: null,
    dir: 'ltr'
  }

  clientId = null

  async componentWillMount() {
    const parsedUrl = urlToObject(window.location.href)
    const { client_id: clientId = null } = parsedUrl
    this.clientId = clientId
    try {
      const profile = await getProfile('getprofile')
      this.setState({ isInit: true, profile })
    } catch (e) {
      const { parent_origin: parentOrigin } = parsedUrl
      const { serverHost, env } = ENV
      const devParam = env === 'prod' ? '' : 'dev=true'
      const defaultLoginHost = getLoginHostUrl() || serverHost
      window.location.href = `${parentOrigin ||
      defaultLoginHost}/na/login/?return_url=${encodeURIComponent(window.location.href)}&${devParam}`
    }
  }

  componentDidMount() {
    const url = document?.location?.href
    if (url?.includes(schema.AE)) {
      this.setState({ dir: 'rtl' })
    }
  }

  handleTokenize = async braintreeToken => {
    this.setState({ isLoading: true, submitError: null })
    try {
      const { paymentMethodId } = await addCard({ braintreeToken, clientId: this.clientId })

      if (paymentMethodId) {
        this.handleSuccess(paymentMethodId)
      } else {
        this.handleError()
      }
    } catch (err) {
      const submitError = err ? prepareErrorMessage(err.toString()) : 'Something went wrong. Please try again.'
      this.setState({ isLoading: false, submitError })
    }
  }

  handleError = () => {
    this.setState({ isLoading: false })
  }

  handleSuccess = paymentMethodId => {
    passInfoToOpenerOrRedirect(paymentMethodId)
  }

  render() {
    const isSlateCard = window.location.search.includes('slate=1')
    return (
      <div dir={this.state.dir}>
        <h1 className="h1">{isSlateCard ? 'Please enter your credit card information for Slate Shuttles' : 'Please enter your credit card information'}</h1>
        <div className="add-card-invoice">
          {
              this.state.isInit ? (
                <AddCardForm
                  isArabic={this.state.dir === 'rtl'}
                  className="add-card-invoice__form"
                  isLoading={this.state.isLoading}
                  onTokenize={this.handleTokenize}
                  onError={this.handleError}
                  submitError={this.state.submitError}
                  withZIP={isUSPhoneNumber(this.state.profile.client.phone)}
                />
              ) : <Spinner />
            }
        </div>
      </div>
    )
  }
}
